"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseLogContextManager = void 0;
const resource_1 = require("./resource");
const tracing_1 = require("./tracing");
class BaseLogContextManager {
    get() {
        return Object.assign(Object.assign(Object.assign({}, (0, tracing_1.getTracingContext)()), (0, resource_1.getResourceContext)()), this.getExecutionContext());
    }
}
exports.BaseLogContextManager = BaseLogContextManager;
//# sourceMappingURL=index.js.map